import React from 'react';
import {
    Alert,
    Box,
    Link as MuiLink,
    Stack,
    Typography,
} from '@mui/material';
import {Link as RouterLink} from 'react-router';
import TabEmpty from './TabEmpty';
import TabLoading from './TabLoading';
import {preloadWhiteboardEditor} from '../../whiteboards/preloadWhiteboardEditor';

function LinkList({items, emptyLabel}) {
    if (!items.length) {
        return (
            <Typography variant="body2" color="text.secondary">
                {emptyLabel}
            </Typography>
        );
    }

    return (
        <Stack spacing={0.75}>
            {items.map((item, idx) => {
                const key = item.id || item.href || `${idx}`;
                const title = item.title || item.id || 'Untitled';
                const linkBody = (
                    <Typography variant="body2" component="span">
                        {title}
                    </Typography>
                );

                if (item.href) {
                    return (
                        <MuiLink
                            key={key}
                            component={RouterLink}
                            to={item.href}
                            underline="hover"
                            color="inherit"
                            onMouseEnter={preloadWhiteboardEditor}
                        >
                            {linkBody}
                        </MuiLink>
                    );
                }

                return <Box key={key}>{linkBody}</Box>;
            })}
        </Stack>
    );
}

/**
 * Charts tab — whiteboards containing this entity.
 *
 * @param {Object} props
 * @param {Array} [props.charts]
 * @param {boolean} props.loading
 * @param {Error|null} [props.error]
 */
const EntityChartsTab = ({
    charts = [],
    loading,
    error = null,
}) => {
    if (loading) return <TabLoading/>;

    if (error) {
        return (
            <Box p={2}>
                <Alert severity="error">
                    {error.message || 'Failed to load charts.'}
                </Alert>
            </Box>
        );
    }

    if (!charts.length) {
        return <TabEmpty message="This entity does not appear on any other charts."/>;
    }

    return (
        <Stack spacing={1} px={2} py={2}>
            <Typography variant="subtitle2" fontWeight={700}>
                Charts ({charts.length})
            </Typography>
            <LinkList items={charts} emptyLabel="None"/>
        </Stack>
    );
};

export default EntityChartsTab;
